import { ThemeConfig } from "antd"

export const transfarioThemeColors = {
  "--color-bg-layout": "#edf6ff",
  "--color-ghost-bg": "#F1F5FF",
  "--color-primary": "#223973",
  "--color-primary-active": "#2d4c9a",
  "--color-primary-bg": "#f1f5ff",
  "--color-primary-hover": "#1c2e5e",
  "--color-table-header-bg": "#f1f5ff",
  "--color-table-row-expanded-bg": "#fff",

  "--font-family": "Ubuntu, sans-serif",

  "--primary-gradient": `
    radial-gradient(
      117.93% 122.91% at 105.19% 107.49%,
      #223973 0%,
      #4962a0 100%
    )
  `,
}

export const TRANSFARIO_ANT_THEME: ThemeConfig = {
  components: {
    Button: {
      defaultGhostColor: transfarioThemeColors["--color-primary"],
      ghostBg: transfarioThemeColors["--color-ghost-bg"],
    },
    Table: {
      headerBg: transfarioThemeColors["--color-table-header-bg"],
      rowExpandedBg: "#FFF",
    },
  },
  token: {
    colorBgLayout: transfarioThemeColors["--color-bg-layout"],
    colorInfo: transfarioThemeColors["--color-primary"],
    colorPrimary: transfarioThemeColors["--color-primary"],
    colorPrimaryActive: transfarioThemeColors["--color-primary-active"],
    colorPrimaryBg: transfarioThemeColors["--color-primary-bg"],
    colorPrimaryHover: transfarioThemeColors["--color-primary-hover"],
    fontFamily: transfarioThemeColors["--font-family"],
  },
}
